import * as Yup from 'yup';

export const toOptionalNumber = (
  schema: Yup.NumberSchema<number | undefined>
) =>
  schema.transform((val, orig) =>
    orig === '' || orig === null ? undefined : val
  );

const requiredText = () => Yup.string().trim().required('Required');

export const marineHullValidationSchema = () =>
  Yup.object({
    marineHullDetails: Yup.object({
      vesselName: requiredText(),
      connectionPort: requiredText(),
      territorialWaters: requiredText(),
      usage: requiredText(),
      builder: requiredText(),
      constructionYear: requiredText(),
      registeryPort: requiredText(),
      engineType: requiredText(),
      engineNumber: requiredText(),
      engineYearBuilt: requiredText(),
      engineHorsePower: requiredText()
    })
  });
